import { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthContext } from '../context/auth';
import { isTapOnPhoneMerchant } from '../utils/companyType';

import { Navbar } from '../components/ui/Navbar';
import { TransactionPage } from '../pages/reports/transaction/TransactionPage';
import { TransactionsProvider } from '../context/transactions/TransactionContext';
import { UsersPage } from '../pages/user/UsersPage';
import { WelcomenPage } from '../pages/welcomePage';
import { UsersProvider } from '../context/users/UserContext';
import { MerchantsProvider } from '../context/merchants/MerchantContext';
import { MerchantsPage } from '../pages/merchant/MerchantsPage';
import { MerchantPage } from '../pages/merchant/MerchantPage';
import { UserPage } from '../pages/user/UserPage';
import { BanksProvider } from '../context/bank/BankContext';
import { BanksPage } from '../pages/bank/BanksPage';
import { GroupsPage } from '../pages/group/GroupsPage';
import { GroupsProvider } from '../context/group/GroupContext';
import { ProductsProvider } from '../context/products/ProductContext';
import { ProductsPage } from '../pages/product/ProductsPage';
import { ProductImportPage } from '../pages/product/ProductImportPage';
import { ModifiersPage } from '../pages/product/ModifiersPage';
import { PriceSchedulesPage } from '../pages/product/PriceSchedulesPage';
import { KitchenPage } from '../pages/kitchen/KitchenPage';
import { TipsPage } from '../pages/reports/tips/TipsPage';
import { TipSettingsPage } from '../pages/tips/TipSettingsPage';
import { RestaurantReportPage } from '../pages/reports/restaurant/RestaurantReportPage';
import { MenuPage } from '../pages/product/MenuPage';
import { ProductPage } from '../pages/product/ProductPage';
import SearchPage from '../pages/product/SearchProduct';
import SearchProductPage from '../pages/product/SearchProduct';
import { AuthProvider } from '../context/auth';
import ChangePassword from '../pages/login/ChangePassword';
import { TablesProvider } from '../context/table/TableContext';
import { TablePage } from '../pages/table/TablePage';
import { TablesPage } from '../pages/table/tablesPage';
import { PrintersProvider } from '../context/printers/PrinterContext';
import { PrintersPage } from '../pages/printer/PrintersPage';
import { PrinterPage } from '../pages/printer/PrinterPage';
import { WaitersProvider } from '../context/waiter/WaiterContext';
import { WaitersPage } from '../pages/waiter/WaitersPage';
import { WaiterPage } from '../pages/waiter/WaiterPage';
import { SuppliersProvider } from '../context/supplier/SupplierContext';
import { StocksPage } from '../pages/stock/StocksPage';
import { StockPage } from '../pages/stock/StockPage';
import { StocksProvider } from '../context/stock/StockContext';
import { PurchasesPage } from '../pages/stock/PurchasesPage';
import { PurchasePage } from '../pages/stock/PurchasePage';
import { TransfersPage } from '../pages/stock/TransfersPage';
import { PhysicalCountPage } from '../pages/stock/PhysicalCountPage';
import { KardexPage } from '../pages/stock/KardexPage';
import { InventorySettingsPage } from '../pages/stock/InventorySettingsPage';
import { CategoriesProvider } from '../context/category/CategoryContext';
import { CategoriesPage } from '../pages/stock/CategoriesPage';
import { CategoryPage } from '../pages/stock/CategoryPage';
import { SuppliersPage } from '../pages/supplier/SuppliersPage';
import { SupplierPage } from '../pages/supplier/SupplierPage';
import { AvailableStockPage } from '../pages/stock/AvailableStockPage';
import { StockMovementsPage } from '../pages/stock/StockMovementsPage';
import { LowStockPage } from '../pages/stock/LowStockPage';
import { CombosProvider } from '../context/combo/ComboContext';
import { CombosPage } from '../pages/combo/CombosPage';
import { ComboPage } from '../pages/combo/ComboPage';
import { SectionsProvider } from '../context/section/SectionContext';
import { SectionsPage } from '../pages/section/SectionsPage';
import { SectionPage } from '../pages/section/SectionPage';
import { ReportsProvider } from '../context/report/ReportContext';
import { MerchantPaymentReport } from '../pages/reports/admin/MerchantPaymentReport';
import { LoyaltyProvider } from '../context/loyalty/LoyaltyContext';
import { RewardsPage } from '../pages/reward/RewardsPage';
import { RewardPage } from '../pages/reward/RewardPage';
import { LoyaltyClientPage } from '../pages/loyalty/client/LoyaltyClientPage';
import { SearchLoyaltyClientPage } from '../pages/loyalty/client/SearchLoyaltyClientPage';
import { InfoLoyaltyClientPage } from '../pages/loyalty/client/InfoLoyaltyClientPage';
import { LoyaltySettingsPage } from '../pages/loyalty/settings/LoyaltySettingsPage';
import { AccountingPage } from '../pages/accounting/AccountingPage';
import { TableLayoutPage } from '../pages/table/layout/TableLayoutPage';
import { TariffsPage } from '../pages/tariff/TariffsPage';
import { TariffsProvider } from '../context/tariff/TariffContext';
import { TariffPage } from '../pages/tariff/TariffPage';
import { MerchantAccountsProvider } from '../context/merchantAccounts/MerchantAccountContext';
import { MerchantAccountsPage } from '../pages/merchantAccount/MerchantAccountsPage';
import { MerchantAccountPage } from '../pages/merchantAccount/MerchantAccountPage';
import { MerchantTerminalsProvider } from '../context/merchantTerminals/MerchantTerminalContext';
import { MerchantTerminalsPage } from '../pages/merchantTerminal/MerchantTerminalsPage';
import { LinkPagoProvider } from '../context/linkPago/LinkPagoContext';
import { LinksPagoAdminPage } from '../pages/linkPagoAdmin/LinksPagoAdminPage';
import { LinkPagoAdmin } from '../pages/linkPagoAdmin/LinkPagoAdminPage';
import { ElectronicInvoiceReport } from '../pages/reports/electronicInvoice/ElectronicInvoiceReport';
import { SalesReport } from '../pages/reports/sales/SalesReport';
import { InvoiceProductCategoryReport } from '../pages/reports/invoiceProductCategory/InvoiceProductCategoryReport';
import { InvoiceResumenByTariffReport } from '../pages/reports/invoiceResumenByTariff/InvoiceResumenByTariffReport';
import { MerchantTopPage } from '../pages/merchant/MerchantTop';
import { MyFeaturesPage } from '../pages/features/MyFeaturesPage';
import { MerchantFeaturesPage } from '../pages/features/MerchantFeaturesPage';
import { SubscriptionsReportPage } from '../pages/features/SubscriptionsReportPage';
import { PAYFAC_SIGNUP_ENABLED } from '../utils/appConfig';
import { BankFeaturesPage } from '../pages/features/BankFeaturesPage';
import { BankBillingPage } from '../pages/features/BankBillingPage';
import { ElectronicInvoiceSettingsPage } from '../pages/electronicInvoice/ElectronicInvoiceSettingsPage';
import { PaymentAttemptsPage } from '../pages/reports/paymentAttempts/PaymentAttemptsPage';

export const DashboardRoutes = () => {
  const { user } = useContext(AuthContext);
  // Comercio Tap on Phone: sin reporte de facturas, de ventas ni de facturación de productos por categoría
  const isTapOnPhone = isTapOnPhoneMerchant(user?.merchant);

  return (

    <>

      {/* Menú lateral y barra superior alrededor de las pantallas */}
      <Navbar>
        <Routes>
          <Route
            path="/"
            element={<MerchantsProvider> <WelcomenPage /></MerchantsProvider>} />
          {/* Comercios */}
          <Route
            path="merchants"
            element={<MerchantsProvider> <MerchantsPage /> </MerchantsProvider>} />

          <Route
            path="merchant"
            element={<MerchantsProvider> <MerchantPage /> </MerchantsProvider>} />

          <Route
            path="merchant/tariffs"
            element={<AuthProvider> <TariffsProvider> <TariffsPage /> </TariffsProvider></AuthProvider>} />

          <Route
            path="merchant/tariff"
            element={<AuthProvider> <TariffsProvider> <TariffPage /> </TariffsProvider></AuthProvider>} />

          <Route
            path="merchant/accounts"
            element={<AuthProvider> <MerchantAccountsProvider> <MerchantAccountsPage /> </MerchantAccountsProvider></AuthProvider>} />

          <Route
            path="merchant/account"
            element={<AuthProvider> <MerchantAccountsProvider> <MerchantAccountPage /> </MerchantAccountsProvider></AuthProvider>} />

          <Route
            path="merchant/terminals"
            element={<AuthProvider> <MerchantTerminalsProvider> <MerchantTerminalsPage /> </MerchantTerminalsProvider></AuthProvider>} />

          {/* Funcionalidades: las del comercio en sesión, el reporte por comercio y la oferta del banco */}
          <Route
            path="my-features"
            element={<MyFeaturesPage />} />

          <Route
            path="reports/merchant-features"
            element={<MerchantFeaturesPage />} />

          {/* Solo en la instancia Swiftmart (Swiftpay): los demás bancos tienen Funcionalidades por comercio */}
          <Route
            path="reports/merchant-subscriptions"
            element={PAYFAC_SIGNUP_ENABLED ? <SubscriptionsReportPage /> : <Navigate to="/" replace />} />

          <Route
            path="bank-features"
            element={<BankFeaturesPage />} />

          <Route
            path="reports/bank-billing"
            element={<BankBillingPage />} />

          {/* Seguimiento de intentos de pago con tarjeta (3DS) */}
          <Route
            path="reports/payment-attempts"
            element={<PaymentAttemptsPage />} />

          {/* Facturación electrónica del comercio en sesión (Costa Rica y Panamá) */}
          <Route
            path="electronic-invoice-settings"
            element={<ElectronicInvoiceSettingsPage />} />

          {/* Bancos */}
          <Route
            path="banks"
            element={<BanksProvider> <BanksPage /> </BanksProvider>} />


          {/* Grupos y permisos */}
          <Route
            path="groups"
            element={<GroupsProvider> <GroupsPage /> </GroupsProvider>} />

          {/* Usuarios */}
          <Route
            path="users"
            element={<UsersProvider> <UsersPage /> </UsersProvider>} />

          <Route
            path="user"
            element={<UsersProvider> <UserPage /> </UsersProvider>} />

          {/* Product */}
          <Route
            path="products"
            element={<ProductsProvider> <StocksProvider autoLoad={false}> <CategoriesProvider> <SuppliersProvider> <CombosProvider> <ProductsPage /> </CombosProvider> </SuppliersProvider> </CategoriesProvider> </StocksProvider> </ProductsProvider>} />

          <Route
            path="products/import"
            element={<ProductImportPage />} />

          <Route
            path="products/modifiers"
            element={<ModifiersPage />} />

          <Route
            path="products/schedules"
            element={<PriceSchedulesPage />} />

          <Route
            path="kitchen"
            element={<KitchenPage />} />

          <Route
            path="reports/tips"
            element={<TipsPage />} />

          <Route
            path="tips/settings"
            element={<TipSettingsPage />} />

          <Route
            path="reports/restaurant"
            element={<RestaurantReportPage />} />

          <Route
            path="menu"
            element={<ProductsProvider> <MenuPage /> </ProductsProvider>} />

          <Route
            path="product"
            element={<ProductsProvider> <ProductPage /> </ProductsProvider>} />

          <Route
            path="search-product"
            element={<ProductsProvider> <SearchProductPage /> </ProductsProvider>} />




          {/* Mesas */}
          <Route
            path="tables"
            element={<TablesProvider> <TablesPage /> </TablesProvider>} />

          {/* Plano de mesas por sección (lo muestra el POS) */}
          <Route
            path="tables/layout"
            element={<TablesProvider> <TableLayoutPage /> </TablesProvider>} />

          <Route
            path="table"
            element={<TablesProvider> <TablePage /> </TablesProvider>} />

          {/* Impresoras */}
          <Route
            path="printers"
            element={<PrintersProvider> <PrintersPage /> </PrintersProvider>} />

          <Route
            path="printer"
            element={<PrintersProvider> <PrinterPage /> </PrintersProvider>} />

          {/* Meseros */}
          <Route
            path="waiters"
            element={<WaitersProvider> <WaitersPage /> </WaitersProvider>} />

          <Route
            path="waiter"
            element={<WaitersProvider> <WaiterPage /> </WaitersProvider>} />

          {/* Proveedores */}
          <Route
            path="suppliers"
            element={<SuppliersProvider> <SuppliersPage /> </SuppliersProvider>} />

          <Route
            path="supplier"
            element={<SuppliersProvider> <SupplierPage /> </SuppliersProvider>} />

          {/* Inventario */}
          <Route
            path="stocks"
            element={<StocksProvider> <CategoriesProvider> <StocksPage /> </CategoriesProvider> </StocksProvider>} />

          <Route
            path="stock"
            element={<StocksProvider> <SuppliersProvider> <CategoriesProvider> <StockPage /></CategoriesProvider> </SuppliersProvider> </StocksProvider>} />

          <Route
            path="modify-stock"
            element={<StocksProvider> <AvailableStockPage /> </StocksProvider>} />

          <Route
            path="stock-movements"
            element={<StocksProvider> <StockMovementsPage /> </StocksProvider>} />

          <Route
            path="low-stock"
            element={<StocksProvider> <LowStockPage /> </StocksProvider>} />

          {/* Costeo del inventario */}
          <Route path="stock-purchases" element={<PurchasesPage />} />
          <Route path="stock-purchase" element={<PurchasePage />} />
          <Route path="stock-transfers" element={<TransfersPage />} />
          <Route path="stock-count" element={<PhysicalCountPage />} />
          <Route path="stock-kardex" element={<KardexPage />} />
          <Route path="stock-settings" element={<InventorySettingsPage />} />

          {/* Categorías de producto */}
          <Route
            path="categories"
            element={<CategoriesProvider> <CategoriesPage /> </CategoriesProvider>} />

          <Route
            path="category"
            element={<CategoriesProvider> <CategoryPage /> </CategoriesProvider>} />

          {/* Combos */}
          <Route
            path="product-stock"
            element={<CombosProvider> <CombosPage /> </CombosProvider>} />

          <Route
            path="add-product-stock"
            element={<CombosProvider> <StocksProvider> <ComboPage /> </StocksProvider> </CombosProvider>} />

          {/* Empresa cliente: se unió a Mi empresa (company-top) */}
          <Route
            path="company"
            element={<Navigate to="/company-top" replace />} />

          {/* Impresoras */}
          <Route
            path="sections"
            element={<SectionsProvider> <SectionsPage /> </SectionsProvider>} />

          <Route
            path="section"
            element={<SectionsProvider> <SectionPage /> </SectionsProvider>} />

          {/* LinkPago */}
          <Route
            path="link-pago-admin"
            element={<LinkPagoProvider> <LinksPagoAdminPage /> </LinkPagoProvider>} />

          <Route
            path="create-link-pago"
            element={<LinkPagoProvider> <LinkPagoAdmin /> </LinkPagoProvider>} />

          {/* Recompensas */}
          {/* Contabilidad (módulo con su propio menú y rutas #/...) */}
          <Route
            path="accounting"
            element={<AccountingPage />} />

          {/* Programa de lealtad: clientes, configuración y recompensas */}
          <Route
            path="loyalty/settings"
            element={<LoyaltyProvider> <LoyaltySettingsPage /> </LoyaltyProvider>} />

          <Route
            path="loyalty/rewards"
            element={<LoyaltyProvider> <RewardsPage /> </LoyaltyProvider>} />

          <Route
            path="loyalty/rewards/reward"
            element={<LoyaltyProvider> <RewardPage /> </LoyaltyProvider>} />

          {/* Cliente plan de lealtad */}
          <Route
            path="loyalty/clients"
            element={<LoyaltyProvider> <SearchLoyaltyClientPage /> </LoyaltyProvider>} />

          <Route
            path="loyalty/clients/client"
            element={<LoyaltyProvider> <LoyaltyClientPage /> </LoyaltyProvider>} />

          <Route
            path="loyalty/clients/client/info"
            element={<LoyaltyProvider> <InfoLoyaltyClientPage /> </LoyaltyProvider>} />


          {/* Reports */}
          <Route
            path="reports/merchant-payment"
            element={<ReportsProvider> <MerchantPaymentReport /> </ReportsProvider>} />

          {/* Transacciones */}
          <Route
            path="reports/transactions"
            element={<TransactionsProvider><MerchantsProvider> <TransactionPage /> </MerchantsProvider> </TransactionsProvider>} />

          {/* Facturacion Electronica */}
          <Route
            path="reports/electronic-invoices"
            element={isTapOnPhone ? <Navigate to="/" replace /> : <ReportsProvider> <ElectronicInvoiceReport /> </ReportsProvider>} />

          {/* Reporte de facturas */}
          <Route
            path="reports/sales"
            element={isTapOnPhone ? <Navigate to="/" replace /> : <ReportsProvider> <SalesReport /> </ReportsProvider>} />

          {/* Facturacion Electronica */}
          <Route
            path="reports/invoice-product-category"
            element={isTapOnPhone ? <Navigate to="/" replace /> : <ReportsProvider> <InvoiceProductCategoryReport /> </ReportsProvider>} />

          {/* Facturacion Electronica Resumen Por Tarifa*/}
          <Route
            path="reports/invoice-tariff"
            element={<ReportsProvider> <InvoiceResumenByTariffReport /> </ReportsProvider>} />

          {/* Mi empresa */}
          <Route
            path="company-top"
            element={<MerchantsProvider> <MerchantAccountsProvider> <MerchantTopPage /> </MerchantAccountsProvider></MerchantsProvider>} />

          {/* Categoria por productos*/}
          <Route
            path="inventory/category"
            element={<CategoriesProvider> <CategoriesPage /> </CategoriesProvider>} />





        </Routes>
      </Navbar>


    </>

  )
}